// extracted by mini-css-extract-plugin
export default {"changelogNoResult":"styles-module--changelogNoResult--39utW","changelogNoResultIcon":"styles-module--changelogNoResultIcon--1bpw0"};